import { Route, Navigate } from 'react-router-dom';
import GiftCardPage from './pages/GiftCardPage';
import GiftCardConfigPage from './pages/GiftCardConfigPage';
import { usePestanaActiva } from '../../components/common/PestanasModulo';
import { GIFT_TAB_IDS } from './pestanas';

// F3 reorden (24-oct-2026): Gift Cards es UNA pantalla con pestañas. ?tab=enviar (defecto) = la página de envío;
// ?tab=ajustes = la antigua «Config. Gift Cards». La ruta vieja sigue viva y redirige (FAQ, enlaces guardados, costumbre).
const GiftCardsModulePage = () => (usePestanaActiva(GIFT_TAB_IDS) === 'ajustes' ? <GiftCardConfigPage /> : <GiftCardPage />);

export const GiftCardRoutes = [
  <Route key="gift-cards" path="/dashboard/gift-cards" element={<GiftCardsModulePage />} />,
  <Route key="gift-card-config" path="/dashboard/gift-card-config" element={<Navigate to="/dashboard/gift-cards?tab=ajustes" replace />} />,
];
